<template>
	<div class="mgrupoenvasadoFormHeader puiformheader">
	</div>
</template>

<script>
import { PuiFormHeaderMixin } from '@Pui9Components';

export default {
	name: 'mgrupoenvasado-form-header',
	mixins: [PuiFormHeaderMixin],
	data() {
		return {
			modelName: 'mgrupoenvasado'
		};
	},
	computed: {
	}
}
</script>
